import { HttpHeaders, HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { TokenService } from '../core/token/token.service';

@Injectable({
  providedIn: 'root'
})
export class ConfiguracaoTemplateService {
  private apiUrl = environment.apiGestorUrlLocal;
  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json', 'authorization': this.tokenService.getToken(), 'session': this.tokenService.getSessionUsuario() }),
    params: {}
  };

  constructor(private http: HttpClient, private tokenService: TokenService) { }

  listagemTemplates(params, filtros): Observable<any> {
    this.httpOptions.params = params;
    return this.http.post(`${this.apiUrl}api/template-resposta/listagem`, filtros, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  excluirTemplates(id: any): Observable<any> {
    this.httpOptions.params = '';
    return this.http.delete(`${this.apiUrl}api/template-resposta/delete/${id}`, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  dropdownMacros(params?): Observable<any> {
    this.httpOptions.params = params ? params : '';
    return this.http.get(`${this.apiUrl}api/template-resposta/dropdown-macros`, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  cadastroTemplates(payload: any): Observable<any> {
    this.httpOptions.params = '';
    return this.http.post(`${this.apiUrl}api/template-resposta/salvar`, payload, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  atualizarTemplates(payload: any, id: number): Observable<any> {
    this.httpOptions.params = '';
    return this.http.put(`${this.apiUrl}api/template-resposta/atualizar/${id}`, payload, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  clonarTemplate(id: number, payload: { name: string; aplicar: string; status: boolean }): Observable<any> {
    this.httpOptions.params = '';
    return this.http.post(`${this.apiUrl}api/template-resposta/${id}/clone`, payload, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      console.error('Ops! Ocorreu um erro:', error.error);
    } else {
      console.error(
        `Backend retornou o código ${error.status}, ` +
        `o body é:`, error);
    }
    return throwError(
      error.error);
  }
}
